import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import BottomNavbar from './BottomNavbar';

import type { FC, ReactNode } from 'react';

interface MainLayoutProps {
  children?: ReactNode;
}

const MainLayout: FC<MainLayoutProps> = () => (
  <>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Outlet />
    </Box>
    <BottomNavbar />
  </>
);

export default MainLayout;
